export default __webpack_public_path__ + "linuxeafa53.png";